var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vehicle)?_c('div',[_c('VehicleReadOnlyInfo',{attrs:{"vehicle":_vm.vehicle}}),_c('RentalsPageTab',{attrs:{"vehicle":_vm.vehicle}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }